import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useLocation } from '@reach/router';
import { breadCrumbItems as breadCrumbItemsType } from '../../../types';

import { PBSLink } from '../link';
import { getLocale, buildLink } from '../../../utils/locale';

const BreadCrumbs = ({ breadCrumbItems, className, titleOverride }) => {
	const breadCrumbItemsLength = breadCrumbItems.length - 1;
	const location = useLocation();
	const locale = getLocale(location.pathname);

	return (
		<section
			className={clsx(
				'px-3 pt-4 pb-8 mx-auto md:pt-4 lg:pb-12 max-w-m-screen lg:px-8',
				className
			)}
		>
			<ul>
				{breadCrumbItems
					.map(({ title, url }, index) => {
						if (index !== breadCrumbItemsLength) {
							return (
								<PBSLink
									variant="Unset"
									to={buildLink(locale, url) || ''}
									className="underline"
								>
									{title}
								</PBSLink>
							);
						}
						return title;
					})
					.map((item, index) => (
						<li
							key={item?.props ? item.props.children : item}
							className="text-s-f pr-2 md:pr-xxs-f after:content-['/'] md:after:pl-xxs-f after:pl-2 last:after:content-none after:font-centra-light last:pr-0 inline"
						>
							{index === breadCrumbItemsLength && titleOverride
								? titleOverride
								: item}
						</li>
					))}
			</ul>
		</section>
	);
};

BreadCrumbs.defaultProps = {
	className: '',
	titleOverride: '',
};

BreadCrumbs.propTypes = {
	className: PropTypes.string,
	breadCrumbItems: breadCrumbItemsType.isRequired,
	titleOverride: PropTypes.string,
};

export { BreadCrumbs };
